import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-123">
      <div className="max-w-5xl mx-auto" data-id="element-124">
        <div className="flex flex-col md:flex-row-reverse items-center gap-10 md:gap-16" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/khhuBraptshXUhbB7tmJGh/Gemini_Generated_Image_syzw02syzw02syzw.jpg" alt="Mujer durmiendo en paz" className="w-full h-auto rounded-xl shadow-2xl border border-[#2a3150]" data-id="element-127" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2 space-y-6" data-id="element-128">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white leading-tight" data-id="element-129">
              El silencio que creías perdido
            </h2>

            <div className="w-16 h-1 bg-[#d4a853] rounded-full" data-id="element-130"></div>

            <p className="text-gray-300 text-lg leading-relaxed pt-4" data-id="element-131">
              En los primeros 7 días, pasarás de despertarte con el corazón
              acelerado a notar que el zumbido se siente "lejano", como si fuera
              el motor de un refrigerador en otra habitación.
            </p>

            <p className="text-gray-300 text-lg leading-relaxed" data-id="element-132">
              No es que el ruido se haya ido por arte de magia, es que{' '}
              <strong className="text-white" data-id="element-133">
                tu cerebro finalmente ha decidido que no es importante
              </strong>
              .
            </p>

            <blockquote className="border-l-4 border-[#d4a853] pl-6 py-2 mt-8 italic text-gray-400 text-lg" data-id="element-134">
              "El descanso no es un lujo, es una necesidad biológica.
              Recuperarlo es el primer paso para recuperar tu vida."
            </blockquote>
          </motion.div>
        </div>
      </div>
    </section>;
}